import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import pluralize from 'pluralize';

import Button from '../../../../../../components/global/Button';
import Angle from '../../../../../../components/global/Angle';
import ShoppingBasketIcon from '../../../../../../components/icons/ShoppingBasketIcon';
import DesignEditorHeader, {
  DesignEditorHeaderCenterSlot,
  DesignEditorHeaderLeftSlot,
  DesignEditorHeaderRightSlot,
} from '../../../../../../components/global/DesignEditor/components/DesignEditorHeader';

const propTypes = {
  className: PropTypes.string,
  printProduct: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func,
  onComplete: PropTypes.func.isRequired,
  buttonText: PropTypes.node,
  completeDisabled: PropTypes.bool,
};

const PrintProductConfiguratorHeaderPane = ({
  className,
  printProduct,
  onClose,
  onComplete,
  buttonText = (
    <>
      <ShoppingBasketIcon
        color="#0c84fe"
        className="mr-1 flex-none"
        size={16}
      />
      Add to cart
    </>
  ),
  completeDisabled,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <DesignEditorHeader className={classes}>
      {onClose && (
        <DesignEditorHeaderLeftSlot>
          <Button
            btnStyle="link"
            className="text-bold"
            onClick={onClose}
            style={{ fontSize: '20px' }}
          >
            <Angle direction="left" />
          </Button>
        </DesignEditorHeaderLeftSlot>
      )}

      <DesignEditorHeaderCenterSlot>
        <h3 className="design-editor-header-title">
          Configure your{' '}
          {
            // Always singularize
            pluralize(
              (printProduct?.name ?? '').replace(
                ' (configured as rendered sheets)',
                '',
              ),
              1,
            )
          }
        </h3>
      </DesignEditorHeaderCenterSlot>

      {onComplete && (
        <DesignEditorHeaderRightSlot>
          <Button
            btnSize="sm"
            className="px-4 btn-round"
            btnOutline
            onClick={onComplete}
            disabled={completeDisabled}
          >
            {buttonText}
          </Button>
        </DesignEditorHeaderRightSlot>
      )}
    </DesignEditorHeader>
  );
};

PrintProductConfiguratorHeaderPane.propTypes = propTypes;

export default PrintProductConfiguratorHeaderPane;
